import React from 'react';
import ReactMarkdown from 'react-markdown';
import ReactMoment from 'react-moment';

import './article.styles.scss';

type ArticleProps = {
  title: string;
  thumbnailUrl: string;
  content: string;
  publishedAt: string;
  author: {
    name: string;
    profilePicUrl: string;
  };
  category: string;
};

const Article: React.FC<ArticleProps> = ({
  thumbnailUrl,
  title,
  content,
  publishedAt,
  author: { name, profilePicUrl },
  category,
}) => {
  return (
    <div className="ptb-100">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <div className="blog-details-desc">
              <div className="article-image">
                <img src={thumbnailUrl} alt="article thumbnail" />
              </div>

              <div className="article-content">
                <div className="entry-meta">
                  <ul>
                    <li>
                      <i className="bx bx-folder-open"></i>
                      <span>Category</span>
                      <p>{category}</p>
                    </li>

                    <li>
                      <i className="bx bx-calendar"></i>
                      <span>Published On</span>
                      <ReactMoment format="MMM Do YYYY">
                        {publishedAt}
                      </ReactMoment>
                    </li>
                  </ul>
                </div>

                <h3>{title}</h3>

                <ReactMarkdown source={content} allowDangerousHtml />
              </div>
              <div className="article-author">
                <div className="author-profile-header"></div>
                <div className="author-profile">
                  <div className="author-profile-title">
                    <img
                      src={profilePicUrl}
                      className="shadow-sm"
                      alt="profile"
                    />
                    <h4>{name}</h4>
                    <span className="d-block">Author, Writer</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-4 col-md-12">
                        <BlogSidebar />
                    </div> */}
        </div>
      </div>
    </div>
  );
};

export default Article;
